// Company, role, who invited them and when it expires (NoCompanyView's InvitationOfferSummary): invitation rows and
// the invite-code preview. Screen readers get it as one sentence (the group's label), like iOS's combined element.

import { Building } from 'lucide-react';
import type { InvitationOffer } from '@/contracts/wire';
import { Chip, GT_COLORS, IconBadge } from '@/ui';
import { expiresLine, invitedLine, offerCompany, offerSummaryLabel, ROLE_COLORS, roleTitle } from '../offers';

export function OfferSummary({ offer }: { offer: InvitationOffer }) {
  const expires = expiresLine(offer);
  const invited = invitedLine(offer);
  return (
    <div className="flex items-start gap-3" role="group" aria-label={offerSummaryLabel(offer)}>
      <IconBadge icon={<Building />} color={GT_COLORS.navy} size={44} />
      <div className="min-w-0 flex-1" aria-hidden>
        <p className="line-clamp-2 text-[15px] font-semibold break-words text-fg">{offerCompany(offer)}</p>
        <p className="truncate text-sm text-fg-muted" title={invited}>
          {invited}
        </p>
        {expires && <p className="text-xs text-fg-muted">{expires}</p>}
      </div>
      <span aria-hidden className="mt-0.5">
        <Chip color={ROLE_COLORS[offer.role]} filled={offer.role === 'admin'} size="md">
          {roleTitle(offer.role)}
        </Chip>
      </span>
    </div>
  );
}
